export { default } from "./ResourcePageTermsAndConditionsCheckbox";
